export function sanitizeData(value) {
  let sanitized = value.map(row => {
    const healthyRow = row.map(cell => {
      if (cell === '' || cell === null) return null
      else if (!isNaN(Number(cell))) return Number(cell)
      else return cell
    })
    if (row.interpolations) healthyRow.interpolations = row.interpolations
    return healthyRow
  })
  return sanitized
}

export function convertRowsToData(rows, dims = 1) {
  rows = rows.map(row => row.map(d => d))
  let headers = rows[0].map(d => d)
  // //si no lleva id, se lo metemos (haciendo copia)
  // if(headers[0]!=='id'){
  //   headers = ['id',...headers]
  //   rows = rows.map((r,index)=>[index,...r])
  // }
  const labels = []
  const labelIdx = headers.includes('label') ? headers.indexOf('label') : 0 // Use id as default label
  const years = []
  let yearIdx = headers.indexOf('year')
  if (labelIdx !== 0 && labelIdx < yearIdx) yearIdx--

  for (let row of rows.slice(1)) {
    // labels.push(row.slice(labelIdx, labelIdx + 1)[0])
    if (labelIdx !== 0) labels.push(row.splice(labelIdx, 1)[0])
    else labels.push(row.slice(labelIdx, labelIdx + 1)[0])
    // if (yearIdx > -1) years.push(row.slice(yearIdx, yearIdx + 1)[0])
    if (yearIdx > -1) years.push(row.splice(yearIdx, 1)[0])
  }
  labelIdx != 0 && headers.splice(labelIdx, 1)
  if (yearIdx > -1) headers.splice(yearIdx, 1)

  let data = rows.slice(1).map((row, i) => {
    let rowObject = { id: row[0], label: labels[i], year: years[i] }
    if (dims > 1) {
      rowObject.value = headers.slice(1).map((header, i) => {
        return {
          id: header,
          parentId: row[0],
          value: row[i + 1],
        }
      })
    } else {
      //SOLO cuando es "simple" podemso cambiar el nombre del "value"
      rowObject[headers[1]] = row[1]
    }
    return rowObject
  })
  // console.log("TO (d3)DATA FORMAT:")
  // console.log(data)
  return data
}
/////////////////////////////////////////////

export function transpose(data) {
  let ob = {}
  data.forEach(row => {
    row.value.forEach(col => {
      if (!ob[col.id]) ob[col.id] = { value: [], id: col.id }
      ob[col.id].value.push(col)
    })
  })
  let res = Object.keys(ob).map(key => {
    return { id: ob[key].id, value: ob[key].value }
  })
  return res
}
